export default "__VITE_ASSET___eNz3kk8__"